/* @ngInject */
const matcher = () => {
  const self = {}

  self.contain = (_value, _pattern) => {
    return _value.toString().match(_pattern)
  }

  self.isNumber = (_value) => {
    return _value.toString().match('^[0-9]*[., ]{0,1}[0-9]*$')
  }

  self.isNumberStartingWith0 = (_value) => {
    return _value.toString().match('^[0]+[0-9., ]*$')
  }

  self.containDate = (_value) => {
    return _value.toString().match('date|Date')
  }

  self.containLength = (_value) => {
    return _value.toString().match('length|Length')
  }

  self.isEuro = (_value) => {
    return _value.toString().match('euro|Euro')
  }

  self.containId = (_value) => {
    return _value.toString().match('id|Id')
  }

  self.isWagonId = (_value) => {
    return _value.toString().match('^[0-9]{12}$')
  }

  self.containIntegerReference = (_value) => {
    return _value.toString().match('brakedMass|tare|feet|quantity|integer|position')
  }

  self.containDecimalReference = (_value) => {
    if (_value.toString()
      .match('ratio')) return false
    return _value.toString()
      .match('length|Length|decimal|Decimal|weight|Weight|capacity|Capacity')
  }

  return self
}
export default matcher



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/services/utils/matcher.service.js